import Header, { HeaderProps } from "./Header";

export { Header, HeaderProps };

export default Header;
